export default __webpack_public_path__ + "static/background-4-bf1db996e043ba4596f822bc371cde58.png";